import { render, staticRenderFns } from "./OrderSuccess.vue?vue&type=template&id=62f88580&scoped=true&"
import script from "./OrderSuccess.vue?vue&type=script&lang=js&"
export * from "./OrderSuccess.vue?vue&type=script&lang=js&"
import style0 from "./OrderSuccess.vue?vue&type=style&index=0&id=62f88580&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62f88580",
  null
  
)

export default component.exports